<form autocomplete="off" [formGroup]="formT3" (ngSubmit)="save()">
    <h4>Detalle de fuerza primaria:
        <ng-container *ngIf="t3"><small>{{t3.longtitle}}</small></ng-container>
    </h4>
    <hr>
    <div class="form-group row">

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Título corto</label>
            <input class="form-control" type="text" placeholder="Título corto" formControlName="shorttitle"
                autocomplete="off" [class.is-invalid]="campoNoValido('shorttitle')">
            <small class="text-danger" *ngIf="campoNoValido('shorttitle')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Título largo</label>
            <input class="form-control" type="text" placeholder="Título largo" formControlName="longtitle"
                autocomplete="off" [class.is-invalid]="campoNoValido('longtitle')">
            <small class="text-danger" *ngIf="campoNoValido('longtitle')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-4 col-md-4">
            <label class="form-label">Código</label>
            <input class="form-control lowercase" type="text" formControlName="code"
                [class.is-invalid]="campoNoValido('code')">
            <small class="text-danger" *ngIf="campoNoValido('code')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-4 col-md-4">
            <label class="form-label">Temática</label>
            <select class="form-select form-input" formControlName="idtematic"
                [class.is-invalid]="campoNoValido('idtematic')">
                <option selected disabled value="">Temática...</option>
                <option *ngFor="let tematic of tematics" value="{{tematic.id}}">
                    {{tematic.title}}
                </option>
            </select>
            <small class="text-danger" *ngIf="campoNoValido('idtematic')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-4 col-md-4">
            <label class="form-label">Versión</label>
            <input class="form-control" type="text" formControlName="version" autocomplete="off"
                [class.is-invalid]="campoNoValido('version')">
            <small class="text-danger" *ngIf="campoNoValido('version')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Sumilla</label>
            <textarea class="form-control" formControlName="summary" autocomplete="off"
                [class.is-invalid]="campoNoValido('summary')" rows="4"></textarea>
            <small class="text-danger" *ngIf="campoNoValido('summary')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Descripción</label>
            <textarea class="form-control" formControlName="detail" autocomplete="off" rows="4"></textarea>
        </div>

        <div class="textOnInput col-6 col-md-6">
            <label class="form-label">Fecha de publicación</label>
            <input class="form-control" type="date" formControlName="publication" autocomplete="off"
                [class.is-invalid]="campoNoValido('publication')">
            <small class="text-danger" *ngIf="campoNoValido('publication')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6">
            <label class="form-label">Última actualización</label>
            <input class="form-control" type="date" placeholder="Actualización" formControlName="lastUpdated"
                autocomplete="off" [class.is-invalid]="campoNoValido('lastUpdated')">
            <small class="text-danger" *ngIf="campoNoValido('lastUpdated')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Tags</label>
            <input class="form-control" type="text" placeholder="tag1, tag2, tag3, tag4, tag5." formControlName="tags">
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Imagen</label>
            <div class="label-container ">
                <div class="row">
                    <div class="col-md-9">
                        <div class="input-group">
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary custom-rounded-button" type="button"
                                    (click)="fileInput.click()">
                                    Cargar imagen
                                </button>
                            </div>
                            <input type="text" disabled class="form-control" placeholder="Imagen" formControlName="img">
                        </div>
                        <input #fileInput class="form-file" type="file" id="input-file" (change)="onFileChange($event)"
                            accept="image/png, .jpg, .webp" style="display: none;">
                    </div>
                    <div class="col-md-3">
                        <ng-container *ngIf="formT3.get('img').value != null">
                            <ng-container *ngIf="isUploadDir">
                                <img class="img-fluid" src="{{URL}}{{formT3.get('img').value}}" alt=""
                                    style="height: 120px; width:100px">
                            </ng-container>
                            <ng-container *ngIf="!isUploadDir">
                                <img src="{{formT3.get('img').value}}" alt="No se ha cargado una imagen"
                                    style="height: 50px;">
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Archivo en PDF</label>
            <input class="form-control" type="text" formControlName="urlfile" autocomplete="off">
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Estado</label>
            <div class="label-container align-switch">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="switch1" formControlName="status">
                </div>
            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block"
                        [routerLink]="['/adm/fuerza/list']">
                        Cancelar
                    </button>
                </div>
                <div>
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </div>
            </div>
        </div>
    </div>

</form>